<template>
    <div class="jobSUccussWrap body">
        <Loader :isLoader="loading" />
        <div class="jobSuccessTitle mobileHide">
            <h1 class="title">
                <span>
                    <img class="starTick" src="@/assets/images/post-job/jop-post-tick.svg" alt="tick-bg">
                    <img class="starIcon" src="@/assets/images/post-job/post-white-tick.svg" alt="tick-bg">
                </span>
                Job Post Successfully
            </h1>
            <img class="titleBlueLogo" src="@/assets/images/post-job/job-post-blue-logo.svg" alt="blur-logo">
        </div>

        <div class="jodDetail">
            <div class="jobSuccessTitle">
                <h1 class="title">
                    <span>
                        <img class="starTick" src="@/assets/images/post-job/jop-post-tick.svg" alt="tick-bg">
                        <img class="starIcon" src="@/assets/images/post-job/post-white-tick.svg" alt="tick-bg">
                    </span>
                    Job Post Successfully
                </h1>
                <img class="titleBlueLogo" src="@/assets/images/post-job/job-post-blue-logo.svg" alt="blur-logo">
            </div>
            <div class="jobDetailContainer">
                <h4 class="jobSectionTitle">{{ data?.name }}</h4>
                <ul>
                    <li><span>Salary:</span> {{ data?.minSalary }}-{{ data?.maxSalary }} Per Month</li>
                    <li><span>Education:</span> {{ data?.qualification?.name }}</li>
                    <li><span>Expirence:</span> {{ data?.experience }} Years</li>
                    <li><span>Location:</span> {{ data?.location?.city }}</li>
                </ul>
            </div>
            <div class="underReview">
                <!-- <img src="@/assets/images/post-job/under-review.svg" alt="under-review"> -->
                <span class="tag red">Under Review</span>
            </div>
        </div>

        <div class="jobPostSearch" id="jobSearch">
            <div class="jobPostSearchIcon">
                <img src="@/assets/images/post-job/job-search-gif.gif" alt="search-animation-icon">
            </div>
        </div>

        <div class="topResumeWrap" id="mapDiv" style="display: none;">
            <div class="topResumeContainer">
                <h4 class="jobSectionTitle">Top Resume</h4>
                <div class="topResumeList card-container">
                    <ToggleCard v-for="info in resumes" class='resumeListBlock' :key="info._id" :info="info"
                        :openCard="openCard" @mobile="(id, info) => onViewMobile(id, info)" :showMobile="showMobile"
                        :showCallback="showCallback" :showWhatsapp="showWhatsapp"
                        @whatsapp="(id, info) => getWhatsappLink(id, info)" @callback="(id, info) => getCallback(id, info)"
                        @view="(id, info) => onViewEmployeProfile(id, info)" dateTitle="Active On" :viewed="false" :notify="notify"
                        @hideNotify="hideNotify()" />
                </div>

                <div class="hireBtnWrap">
                    <button type="button" @click="unlockNHire" class="hireBtn">Unlock & Hire <img
                            src="@/assets/images/post-job/btn-blur-logo.svg" alt="blur-logo"></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '@/assets/css/latest-jobs.css'
import '@/assets/css/plan.css'
import $ from 'jquery';
import { mapState } from 'vuex';
import ToggleCard from '../components/common/ToggleCard.vue';
import Cookies from 'js-cookie'
import Loader from '../components/common/Loader.vue'

export default {
    name: "PostJobSuccess",
    data() {
        return {
            resumes: [],
            data: {},
            openCard: {},
            showMobile: {},
            showCallback: {},
            showWhatsapp: {},
            notify: false,
            selectedEmpId: null,
            showMobileOrDetails: 0,
            loading: true
        };
    },
    mounted() {
        const postedJobID = Cookies.get('postedJob');
        if (postedJobID) {
            this.$store.dispatch('EmployerModule/actionFetchPostedJobDetails', postedJobID)
        }
        else {
            this.$router.push("/dashboard");
        }
    },
    watch: {
        resumes() {
            console.log(this.resumes);
        },
        data() {
            console.log(this.data);
        },
        checkViewJob() {
            const doElse = () => {
                this.openCard = {};
                this.showCallback = {};
                this.showMobile = {};
                this.showWhatsapp = {};
                if (this.showMobileOrDetails === 0) {
                    this.$router.push("/database-new");
                } else if (this.showMobileOrDetails === 1) {
                    this.notify = { [this.selectedEmpId]: 1 };
                } else if (this.showMobileOrDetails === 2) {
                    this.notify = { [this.selectedEmpId]: 2 };
                } else if (this.showMobileOrDetails === 3) {
                    this.notify = { [this.selectedEmpId]: 3 };
                }
            };

            this.errorMessage = "";
            if (!this.checkViewJob.isChecking) {
                if (this.checkViewJob.responseData.status === 200) {
                    const link = this.checkViewJob?.responseData?.data?.dataObject?.userDetails?.whatsappLink;
                    if (link) {
                        window.open(link);
                    }
                    this.showWhatsapp = {};
                    if (this.checkViewJob.responseData.data?.dataObject) {
                        const user_data =
                            this.checkViewJob.responseData.data?.dataObject?.userDetails;
                        this.showMobileOrDetails === 0
                            ? this.showCard(this.selectedEmpId, user_data)
                            : this.showMobileOrDetails === 1
                                ? this.showMobileHandler(
                                    this.selectedEmpId,
                                    user_data?.user?.mobile
                                )
                                : this.showMobileOrDetails === 2 ?
                                    this.showCallbackHandler(this.selectedEmpId, true) :
                                    !!this.checkViewJob?.responseData?.data?.whatsAppLink &&
                                    window.open(this.checkViewJob?.responseData?.data?.whatsAppLink)
                    } else {
                        doElse();
                    }
                } else {
                    doElse();
                }
            }
        },
        fetchPostedJob() {
            if (this.fetchPostedJob.isCheckingPlan) {
                this.loading = true
            } else {
                if (this.fetchPostedJob.responseData.status === 200) {
                    this.loading = false
                    const successData = this.fetchPostedJob.responseData.data;
                    this.resumes = successData?.matchingResume;
                    this.data = successData?.data;
                    $(document).ready(function () {
                        $("#jobSearch").delay(1500).fadeOut(300);
                        $("#mapDiv").delay(1500).fadeIn(300);
                        $("#mapDiv").delay(4000).addClass("active");
                    });
                }
            }
        }
    },
    computed: {
        ...mapState({
            checkViewJob: (state) => state.GeneralModule.checkViewJob,
            fetchPostedJob: (state) => state.EmployerModule.fetchPostedJob,
        }),
    },
    methods: {
        toDashboard() {
            this.$router.push('/matching-resume');
        },
        unlockNHire() {
            var now = new Date();
            var time = now.getTime();
            var expireTime = time + 3600 * 1000 * 2 * 1 * 1;
            now.setTime(expireTime);
            this.$router.push('/get-matching-resume/' + this.data._id);
        },
        hideNotify() {
            this.notify = false;
        },
        showCard(id, data) {
            this.openCard = {
                ...this.openCard,
                [id]:
                    data === "load"
                        ? data
                        : this.openCard[id] === "load" || !this.openCard[id]
                            ? data
                            : false,
            };
        },
        showMobileHandler(id, data) {
            this.showMobile = {
                ...this.showMobile,
                [id]:
                    data === "load"
                        ? data
                        : this.showMobile[id] === "load" || !this.showMobile[id]
                            ? data
                            : false,
            };
        },
        showCallbackHandler(id, data) {
            this.showCallback = {
                ...this.showCallback,
                [id]:
                    data === "load"
                        ? data
                        : this.showCallback[id] === "load" || !this.showCallback[id]
                            ? data
                            : false,
            };
        },
        showWhatsappHandler(id, data) {
            this.showWhatsapp = {
                ...this.showWhatsapp,
                [id]:
                    data === "load"
                        ? data
                        : this.showWhatsapp[id] === "load" || !this.showWhatsapp[id]
                            ? data
                            : false,
            };
        },
        // onViewJob(_id, e, show) {
        //     this.showMobileOrDetails = show;
        //     if (show === 0 && !!this.openCard[_id]) {
        //         this.showCard(_id, false);
        //         return;
        //     }
        //     if (show === 1 && !!this.showMobile[_id]) {
        //         this.showMobileHandler(_id, false);
        //         return;
        //     }
        //     if (show === 2 && !!this.showCallback[_id]) {
        //         this.showCallbackHandler(_id, false);
        //         return;
        //     }
        //     if (show === 3 && !!this.showWhatsapp[_id]) {
        //         this.showWhatsappHandler(_id, false);
        //         return;
        //     }
        //     if (show === 3) {
        //         this.showWhatsappHandler(_id, "load");

        //     }
        //     if (show === 2) {
        //         this.showCallbackHandler(_id, "load");
        //     }
        //     if (show === 1) {
        //         this.showMobileHandler(_id, "load");
        //     }
        //     if (show === 0) {
        //         this.showCard(_id, "load");
        //     }
        //     const types = {
        //         0: "details",
        //         1: "mobile",
        //         2: "callback",
        //         3: "whatsapp"
        //     };

        //     this.$store.dispatch("GeneralModule/actionCheckViewJob", {
        //         id: _id,
        //         jobId: this.data._id,
        //         type: types[show],
        //     });
        //     this.selectedEmpId = _id;
        // },
        async onViewEmployeProfile(empId, data) {
            if (!this.openCard[empId])
                this.openCard = { ...this.openCard, [empId]: "load" };
            let employerId = Cookies.get("userId");
            const jwtToken = Cookies.get("authToken");

            if (!jwtToken) this.$router.push("/login");
            let self = this;
            // eslint-disable-next-line no-undef
            nv("event", "View Resume", {
                employerID: employerId,
                jobId: data?._id,
                name: data?.basicInfo?.name,
                email: data?.email,
                mobile: data?.mobile,
                jobProfile: data?.profile?.name,
                location: data?.workLocation
                    ? data.workLocation?.city
                    : data?.workLocality
                        ? data?.workLocality?.city
                        : "",
                companyName:
                    self.employerProfileData?.companyName || "Employer Not Logged In",
                empName:
                    self.employerProfileData?.contactPerson || "Employer Not Logged In",
                empNumber: self.employerProfileData?.contactNumber || null,
                empEmail:
                    self.employerProfileData?.emailAddress || "Employer Not Logged In",
                url: window.location.href,
            });

            if (jwtToken && empId) {
                try {
                    const { status, data } = await this.$store.dispatch(
                        "EmployerModule/actionEmployeeResume",
                        {
                            "viewType": "resume",
                            "type": "details",
                            "id": empId
                        }
                    );

                    if (status === 200) {
                        this.openCard = {
                            ...this.openCard,
                            [empId]: this.openCard[empId] === "load" || !this.openCard[empId] ? data?.dataObject?.userDetails : false,
                        };
                    }
                    if (status !== 200) {
                        let arr = [];
                        let sample = [
                            { name: "Rahul Sharma", profile: "Machine Operator" },
                            { name: "Ashish Yadav", profile: "Constructor" },
                            { name: "Vishal Tripathi", profile: "Tailor" },
                        ];
                        for (let i = 0; i < 3; i++) {
                            if (this.resumes[i].basicInfo && this.resumes[i].profile) {
                                arr.push({
                                    name: this.resumes[i].basicInfo.name || sample[i].name,
                                    profile: this.resumes[i].profile.name || sample[i].profile,
                                });
                            } else {
                                arr.push({
                                    name: sample[i].name,
                                    profile: sample[i].profile,
                                });
                            }
                        }
                        var now = new Date();
                        var time = now.getTime();
                        var expireTime = time + 3600 * 1000 * 2 * 1 * 1;
                        now.setTime(expireTime);
                        Cookies.set("databaseTemp", JSON.stringify(arr), {
                            path: "/",
                            expires: now,
                        });
                        // this.freeResumeExhusted = true;
                        //  this.$message({
                        //   message: "Free Limit Resume has been Consumed",
                        //   type: "error",
                        //   offset: 80,
                        // });
                        this.$router.push("/database-new");
                    }
                    if (status === 404) {
                        if (Cookies.get("authToken")) {
                            this.$router.push("/");
                        } else {
                            this.$router.push("/login");
                        }
                    }
                } catch (error) {
                    //   this.$router.push("/login");
                    console.log('error', error)
                }
            } else {
                this.$router.push("/login");
            }
        },
        async onViewMobile(_id, info) {
            if (this.showMobile[_id]?.toString()?.length === 10) {
                document.location.href = `tel:+91${this.showMobile[_id]}`;
                setTimeout(() => {
                    this.showMobileHandler(_id, false);
                }, 10000);
                return;
            } else {
                this.showMobileHandler(_id, "load");
                const { status, data } = await this.$store.dispatch("EmployerModule/actionEmployeeResume", {
                    "viewType": "resume",
                    "type": "mobile",
                    "id": _id
                });
                if (status !== 200) {
                    this.$router.push("/database-new");
                    return;
                }
                else {
                    if (data?.dataObject?.userDetails) {
                        const user_data = data?.dataObject?.userDetails;
                        this.showMobileHandler(user_data?._id, user_data?.mobile);
                    }
                }
                let employerId = Cookies.get("userId");
                // eslint-disable-next-line no-undef
                nv("event", "View Resume", {
                    //View Mobile
                    employerID: employerId,
                    name: this.employerProfileData?.contactPerson || "",
                    companyName: this.employerProfileData?.companyName || "",
                    email: this.employerProfileData?.emailAddress || "",
                    jobProfile: this.userSkills,
                    jobSeekerName: info.basicInfo ? info.basicInfo.name : "",
                    jobSeekerProfile: info.profile ? info.profile.name : "",
                    jobSeekerLocation: info?.workLocality
                        ? info?.workLocality?.city
                        : info?.workLocation?.city,
                    url: window.location.href,
                });
            }
        },
        async getCallback(_id, info) {
            this.showCallbackHandler(_id, "load");
            const { status } = await this.$store.dispatch("EmployerModule/actionEmployeeResume", {
                "viewType": "resume",
                "type": "callback",
                "id": _id
            });
            if (status !== 200) {
                this.$router.push("/database-new");
                return;
            } else {
                if (this.showCallback[_id] !== "load") {
                    this.showCallbackHandler(_id, false);
                    return;
                } else {
                    this.showCallbackHandler(_id, true);
                }
            }
            let employerId = Cookies.get("userId");
            // eslint-disable-next-line no-undef
            nv("event", "View Resume", {
                //get call back
                employerID: employerId,
                name: this.employerProfileData?.contactPerson || "",
                companyName: this.employerProfileData?.companyName || "",
                email: this.employerProfileData?.emailAddress || "",
                jobProfile: this.userSkills,
                jobSeekerName: info.basicInfo ? info.basicInfo.name : "",
                jobSeekerProfile: info.profile ? info.profile.name : "",
                jobSeekerLocation: info?.workLocality
                    ? info?.workLocality?.city
                    : info?.workLocation?.city,
                url: window.location.href,
            });
        },
        async getWhatsappLink(_id, info) {
            this.showWhatsappHandler(_id, "load");
            const { status, data } = await this.$store.dispatch("EmployerModule/actionEmployeeResume", {
                "viewType": "resume",
                "type": "whatsapp",
                "id": _id
            });
            if (status !== 200) {
                this.$router.push("/database-new");
                return;
            }
            else {
                const link = data?.dataObject?.userDetails?.whatsappLink;
                if (link) {
                    window.open(link);
                }
                this.showWhatsapp = {};
            }
            let employerId = Cookies.get("userId");
            // eslint-disable-next-line no-undef
            nv("event", "View Resume", {
                //View whatsapp
                employerID: employerId,
                name: this.employerProfileData?.contactPerson || "",
                companyName: this.employerProfileData?.companyName || "",
                email: this.employerProfileData?.emailAddress || "",
                jobProfile: this.userSkills,
                jobSeekerName: info.basicInfo ? info.basicInfo.name : "",
                jobSeekerProfile: info.profile ? info.profile.name : "",
                jobSeekerLocation: info?.workLocality
                    ? info?.workLocality?.city
                    : info?.workLocation?.city,
                url: window.location.href,
            });
        }
    },
    components: { ToggleCard, Loader }
}
</script>

<style scoped>
@import './../assets/css/latest-jobs.css';

.body {
    overflow-x: hidden;
}

.body * {
    box-sizing: border-box;
}

.body,
ul,
ol,
label,
h1,
h2,
h3,
h4,
h5,
h6,
p {
    padding: 0;
    margin: 0;
    font-family: 'Gilroy';
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-weight: 700;
}

ul {
    list-style: none;
}

a {
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}


.jobSuccessTitle {
    background-color: #f7f7f7;
    padding: 3rem 1.5rem;
    position: relative;
}

.jobSuccessTitle .title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    font-weight: 600;
    color: #525060;
}

.jobSuccessTitle .title span {
    margin-right: 30px;
    position: relative;
}

.jobSuccessTitle .title .starIcon {
    position: absolute;
    left: 50%;
    top: calc(50% - 3px);
    transform: translate(-50%, -50%);
}


.jobSuccessTitle .title .starTick {
    animation: circleRight 4s linear infinite;
}

@keyframes circleRight {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.jobSuccessTitle .titleBlueLogo {
    position: absolute;
    right: 0;
    top: 0;
}

/* Job Detail*/
.jodDetail {
    background: rgba(0, 160, 228, 0.11);
    border: 1px solid rgba(0, 160, 228, 0.4);
    padding: 36px 20px;
    position: relative;
    margin: 16px;
}

.jobDetailContainer {
    max-width: 600px;
    margin: 0 auto;
}

.jobSectionTitle {
    color: #525060;
    font-size: 22px;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 10px;
}

.jodDetail ul {
    display: flex;
    flex-flow: wrap;
}

.jodDetail ul li {
    font-size: 16px;
    color: #525060;
    margin-top: 15px;
    flex-basis: 50%;
}

.jodDetail ul li span {
    font-weight: 500;
}

.underReview {
    /* position: absolute;
    right: 0;
    bottom: 10px; */
    position: absolute;
    right: 59px;
    bottom: 50px;
    color: white;
}

.underReview span {
    position: absolute;
    /* left: calc(50% + 0px); */
    left: 0px;
    text-align: center;
    font-size: 14px;
    letter-spacing: 1px;
    /* color: #494949; */
    color: white;
    font-weight: 600;
    transform: translateX(-50%);
    top: 4px;
    padding-right: 20px;
    white-space: nowrap;
    padding-left: 24px;
}


/* Search Div */
.jobPostSearch {
    text-align: center;
    background: #ffffff;
    padding: 60px 20px;
}

.jobPostSearch img {
    max-width: 450px;
}


/* Top Resume */
.topResumeWrap {
    background-image: url(../assets/images/post-job/map.svg);
    background-repeat: no-repeat;
    background-size: cover;
    padding: 50px 40px;
    overflow: hidden;
    min-height: 400px;
}

.topResumeList {
    /* display: grid;
    grid-template-columns: 1fr 1fr 1fr; */
    /* gap: 30px; */
}

.resumeListBlock {
    background: #fff;
    box-shadow: 0px 4px 31px rgba(0, 0, 0, 0.2);
    padding: 20px;
    border-radius: 10px;
    margin-top: 20px;
    position: relative;
    width: min(350px, 100%);
    margin: 10px auto;
}

.resumeListBlock:nth-child(1) {
    animation: fadeRight 1s linear;
    animation-iteration-count: 1;
}

.resumeListBlock:nth-child(2) {
    animation: fadeRight 1s linear;
    animation-iteration-count: 1;
}

.resumeListBlock:nth-child(3) {
    animation: fadeRight 1s linear;
    animation-iteration-count: 1;
}

@keyframes fadeRight {
    0% {
        transform: translateX(100px);
    }

    100% {
        transform: translateX(0px);
    }
}

.resumeListBlock ul {
    display: flex;
    flex-flow: wrap;
}

.resumeListBlock ul li {
    padding-left: 30px;
    position: relative;
    font-size: 16px;
    color: #4E4D4D;
    line-height: 26px;
    flex-basis: 50%;
    margin-bottom: 16px;
}

.resumeListBlock ul li.listFullWidth {
    flex-basis: 100%;
}

.resumeListBlock ul li img {
    position: absolute;
    left: 0;
    top: 4px;
}

.resumeListBlock ul li span {
    display: block;
    font-weight: 600;
    font-size: 17px;
}

.resumeDateTag {
    position: absolute;
    right: -8px;
    top: 50%;
}

.resumeDateTag span {
    position: absolute;
    left: 50%;
    top: 50%;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
}

.topResumeBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px dashed #00A0E4;
    padding-top: 12px;
    flex-wrap: wrap;
}

.resumeListBlock .resumeBtn:not(:last-child) {
    margin-right: 8px;
}

.resumeListBlock .resumeBtn {
    padding: 0 10px;
    border-radius: 8px;
    border: 1px solid #00A0E4;
    display: flex;
    align-items: center;
    font-size: 12px;
    margin-top: 8px;
    line-height: 36px;
    font-weight: 700;
    background-color: #fff;
}

.resumeListBlock .resumeBtn img {
    margin-right: 5px;
}

.resumeListBlock .resumeBtn.viewBtn {
    color: #00A0E4;
}

.resumeListBlock .resumeBtn.callbackBtn {
    color: #F07070;
    border-color: #F07070;
}

.resumeListBlock .resumeBtn.mobileBtn {
    color: #83DC8D;
    border-color: #83DC8D;
}

.resumeListBlock .resumeBtn.whatsappBtn {
    padding: 5px;
    border-color: #64B161;
}

.resumeListBlock .resumeBtn.whatsappBtn img {
    margin: 0;
}

.hireBtnWrap {
    text-align: center;
}

.hireBtnWrap .hireBtn {
    background: linear-gradient(280.07deg, #00A0E4 18.38%, #0089C2 78.52%);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    width: 100%;
    max-width: 250px;
    line-height: 52px;
    padding: 0 10px;
    color: #fff;
    font-size: 1.125rem;
    font-weight: 600;
    border-radius: 6px;
    margin-top: 2.5rem;
    position: relative;
    overflow: hidden;
    border: none;
    cursor: pointer;
}

.hireBtnWrap .hireBtn img {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -3px;
    z-index: 0;
}

.card-container {
    display: flex;
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;
}

@media (min-width:768px) {
    .jodDetail .jobSuccessTitle {
        display: none;
    }
}

@media (max-width: 1280px) {
    .topResumeList {
        /* gap: 20px; */
    }
}


@media (max-width: 1200px) {
    .topResumeList {
        /* grid-template-columns: 1fr 1fr; */
    }

    .topResumeWrap {
        padding: 40px 20px;
    }
}

@media (max-width: 767px) {
    .mobileHide {
        display: none;
    }

    .jobSuccessTitle {
        padding: 0rem 0 1rem;
        justify-content: flex-start;
        background-color: transparent;
    }

    .jobSuccessTitle .titleBlueLogo {
        width: 120px;
    }

    .jobSuccessTitle .title {
        font-size: 24px;
        letter-spacing: -0.5px;
        justify-content: flex-start;
    }

    .jobSuccessTitle .title span {
        margin-right: 16px;
    }

    .jobSuccessTitle .title .starTick {
        width: 42px;
    }

    .jobSuccessTitle .title .starIcon {
        width: 16px;
        margin-top: 3px;
    }

    .jodDetail {
        padding: 20px 20px 60px;
    }

    .jobSectionTitle {
        font-size: 19px;
        line-height: 20px;
        margin-bottom: 0;
    }

    .jodDetail ul li {
        font-size: 14px;
        font-weight: 600;
    }

    .jodDetail ul li span {
        font-weight: 400;
        display: block;
        margin-bottom: 5px;
    }

    .topResumeList {
        grid-template-columns: 1fr;
        margin-top: 36px;
    }

    .resumeListBlock {
        margin-top: 0;
    }

    .resumeListBlock ul li {
        padding-left: 24px;
        font-size: 15px;
        margin-bottom: 12px;
        line-height: 22px;
    }

    .resumeListBlock ul li span {
        font-size: 15px;
    }

    .resumeListBlock ul li img {
        width: 14px;
    }

    .topResumeBtn {
        padding-top: 8px;
    }

    .resumeListBlock .resumeBtn {
        padding: 0 8px;
        font-size: 14px;
        line-height: 30px;
        border-radius: 6px;
    }

    .resumeListBlock .resumeBtn.whatsappBtn img {
        width: 20px;
    }

    .hireBtnWrap .hireBtn {
        max-width: 320px;
        line-height: 48px;
        font-size: 1rem;
    }
}
</style>